import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprControlVisibility } from '../props/IWprControlState';
import { WprControlInfo } from '../../view/control/WprControlInfo';
import { WprFramework } from '../../WprFramework';
import { WprBaseInputControlComponent } from './WprBaseInputControlComponent';

/**
 * 入力コントロールプロパティ情報
 */
interface IWprInputProps extends IWprControlProps {
	type?: string;				// タイプ
	placeholder?: string;		// placeholder
}

/**
 * 入力コントロール
 */
export class WprInput extends WprBaseInputControlComponent<IWprInputProps, HTMLInputElement> {
	private m_SelectionStart: any = null;
	private m_SelectionEnd: any = null;
	private m_SelectionDirection: any = null;
	private m_IsReset: boolean = false;

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprInputProps) {
		super(props);
		this.setChangeValueEvent(this.onChangeValue.bind(this));
		this.setSelectionChangeEvent(this.onSelectionChange.bind(this));
	}
	// --------------------------------------------------------------------------

	// イベント  ----------------------------------------------------------------
	/**
	 * 値変更処理
	 * @param event 変更イベント 
	 */
	public onChangeValue(event: React.ChangeEvent<HTMLInputElement>): void {
		// console.info(`Change = ${this.m_SelectionStart}`);
		this.m_IsReset = false;
		const value = event.target.value;
		if (this.controlInfo != null) {
			WprControlInfo.isChangeValue = true;
			try {
				/* IME制御ができないため保留
				if (this.controlInfo.checkInput(value) === false) {
					this.resetPos();
					return;
				}
				*/
				WprFramework.getInstance().view.setScopeUpdateProperty();
				this.controlInfo.dirty = true;
				if (this.props.row) {
					if (this.controlInfo.changeListValue(value, this.props.row.rowData) === false)
						return;
				}
				else {
					if (this.controlInfo.changeValue(value) === false)
						return;
				}
				WprControlInfo.isChangeValue = true;
				this.controlInfo.value = value;
				this.controlInfo.viewCore.viewInfo.checkScopeModelValue();
			}
			finally {
				WprControlInfo.isChangeValue = false;
			}
		}
	}

	/**
	 * 選択変更処理
	 * @param event 選択変更イベント 
	 */
	public onSelectionChange(event: React.ChangeEvent<HTMLInputElement>): void {
		if (this.m_IsReset === true) {
			this.m_IsReset = false;
			event.target.selectionStart = this.m_SelectionStart;
			event.target.selectionEnd = this.m_SelectionEnd;
			event.target.selectionDirection = this.m_SelectionDirection;
		}
		else {
			this.m_SelectionStart = event.target.selectionStart;
			this.m_SelectionEnd = event.target.selectionEnd;
			this.m_SelectionDirection = event.target.selectionDirection;
		}
		// console.info(`POS = ${this.m_SelectionStart}`);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		if (this.state.value == null)
			return '';
		return this.state.value;
	}

	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		const props = this.getProps();
		const {name, view, children, className, placeholder, autoComplete, ...other} = this.props;
		const state = this.getState(['style', 'disabled', 'readOnly', 'min', 'max', 'minLength', 'maxLength']);
		const events = this.getEvents();
		const pholder = this.getPlaceholder();
		const aComplete = this.getAutoComplete();
		let input = null;
		if (this.state.visibility === WprControlVisibility.VISIBLE) {
			input = <input {...props} {...state} {...other} {...events} {...pholder} {...aComplete} />;
		}
		else {
			state['style'] = {...this.state.style, visibility: 'hidden'};
			input = <input {...props} {...state} {...other}/>;
		}
		return (
			<>
				{input}
			</>
		);
	}

	/**
	 * 選択位置リセット処理
	 */
	public resetPos(): void {
		this.m_IsReset = true;
	}
	// --------------------------------------------------------------------------

	// private メソッド  ---------------------------------------------------------
	/**
	 * placeholder情報取得
	 * @returns placeholder情報
	 */
	private getPlaceholder(): any {
		const rtn: any = {};
		if (this.state.placeholder)
			rtn['placeholder'] = this.state.placeholder;
		if (this.props.placeholder)
			rtn['placeholder'] = this.props.placeholder;
		return rtn;
	}

	/**
	 * autoComplete情報取得
	 * @returns autoComplete情報
	 */
	private getAutoComplete() {
		const rtn: any = {};
		if (this.props.autoComplete)
			rtn['autoComplete'] = this.props.autoComplete;
		else
			rtn['autoComplete'] = 'on';
		return rtn;
	}
	// --------------------------------------------------------------------------
}